// The following list was made manually using SauceLab. If it's been a while, feel free to make a new audit to update this list.
export const supportedBrowsers = {
  Chrome: 80,
  Firefox: 80,
  Edge: 80,
  Safari: 14,
} as const
